export default function SharedData() {
    return (
        <section>
            <h2 id="shared-data" data-testid="shared-data">
                IV. COM QUEM COMPARTILHAREMOS OS DADOS
            </h2>
            <p>
                A AMBEV constitui grupo econômico, que trabalha em parceria com
                diversas empresas. Deste modo, poderá compartilhar as
                informações coletadas por meio do App, nas seguintes hipóteses:
            </p>
            <ol type="i">
                <li>
                    Com outras empresas do Grupo AMBEV, constituídas ou atuantes
                    em qualquer país, que se comprometem a utilizar as
                    informações para os mesmos fins indicados na presente
                    Política;
                </li>
                <li>
                    Para proteção dos interesses da AMBEV em qualquer tipo de
                    conflito, incluindo ações judiciais;
                </li>
                <li>
                    No caso de transações e alterações societárias envolvendo a
                    AMBEV, hipótese em que a transferência das informações será
                    necessária para a continuidade dos serviços; ou,
                </li>
                <li>
                    Mediante ordem judicial ou pelo requerimento de autoridades
                    administrativas que detenham competência legal para sua
                    requisição.
                </li>
            </ol>
        </section>
    );
}
